<template>
  <div
    v-if="request.requestType === 'LOG'"
    class="mt-3"
  >
    <div class="mb-1">
      <span>{{ $t('logisticExtrasView.yklnmYeri') }} </span>
      <span class="text-dark">
        {{ requestExtras.pickupCountry }}, {{ requestExtras.pickupCity }}
        <span v-if="requestExtras.pickupAddress">({{ requestExtras.pickupAddress }}) </span>
      </span>
    </div>

    <div class="mb-1">
      <span>{{ $t('logisticExtrasView.boaldlmaYeri') }} </span>
      <span class="text-dark">
        {{ requestExtras.dropOffCountry }}, {{ requestExtras.dropOffCity }}
        <span v-if="requestExtras.dropOffAddress">({{ requestExtras.dropOffAddress }}) </span>
      </span>
    </div>

    <div class="mb-1">
      <span>{{ $t('logisticExtrasView.satcIlRazladrlmIncotermsRti') }} </span>
      <span class="text-dark">
        {{ requestExtras.incoterms }}
      </span>
    </div>

    <div class="mb-1">
      <span>{{ $t('logisticExtrasView.qeydlr') }}</span>
      <span class="text-dark">
        {{ requestExtras.notes }}
      </span>
    </div>


    <div class="mb-1">
      <span>{{ $t('logisticExtrasView.qbulEdilnDanmaNvlri') }}</span> <br>
      <span class="text-dark">
        <div
          v-for="t in requestExtras.types.split(',')"
          :key="t"
        >
          - {{ getDeliveryTypeName(t) }}
        </div>
      </span>
    </div>
  </div>
</template>
<script>
import {getDeliveryTypeName} from "@/repositories/Utils";

export default {
  name: 'LogisticExtrasView',
  props: {
    request: {},
    requestExtras: {type: Object}
  },
  methods: {
    getDeliveryTypeName(key) {
      return getDeliveryTypeName(key);
    },
  }
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
